module.exports = __webpack_public_path__ + "static/solutions-231ab88b6e7fb27ba606c8331f9ca778.webp";